"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");













































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      newadd: false, newadd2: false, urlNames: [], title: '', searchData: { otaVersion: '', enabled: '', isForce: '', // 固件类型 1:中心板 2:wifi板 3:讯飞语音板 4:非讯飞语音板
        firmwareType: '3', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', otaVersion: '', enabled: '1', isForce: '0', firmwareDownloadType: '1', md5: '', path: '', urlList: [], remark: '', firmwareType: '3', // 固件类型1中心板2wifi板3讯飞语音板4非讯飞语音板
        url: '', url2: '', fileList: [] }, defaultData: { id: '', name: '', otaVersion: '', enabled: '1', isForce: '0', firmwareDownloadType: '1', md5: '', path: '', urlList: [], remark: '', firmwareType: '3', url: '', url2: '', fileList: [] }, rules: { otaVersion: [{ required: true, message: '请输入中心板版本', trigger: 'blur' }], isForce: [{ required: true, message: '请选择是否强制升级', trigger: 'blur' }], enabled: [{ required: true, message: '请选择是否启用', trigger: 'blur' }], urlList: [{ required: true, message: '请上传固件文件', trigger: 'change' }], firmwareDownloadType: [{ required: true, message: '请选择下载方式', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'otaVersion', label: '语言版本', isShow: true }, { prop: 'firmwareDownloadType', label: '下载方式', formatter: _formatter.downloadTypeFormatter, isShow: true }, { prop: 'isForce', label: '是否强制升级', formatter: _formatter.isForceFormatter, isShow: true }, { prop: 'enabled', label: '是否启用', formatter: _formatter.statusFormatter, isShow: true }, { prop: 'remark', label: '备注', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/faOtaVersion', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, // 设置imageList
    setImageList: function setImageList(val) {var arr = [];if (val) {arr.push(val);}this.imageSrcList = arr;}, resetFun: function resetFun() {// 重置
      this.searchData.otaVersion = '';this.searchData.enabled = '';this.searchData.isForce = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;if (this.searchData.endTime) {var endTime = this.searchData.endTime;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.endTime = endTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.title = '新增';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, beforeRemove: function beforeRemove(file, fileList) {return this.$confirm('确定移除 ${ file.name } ？');}, onsuccess: function onsuccess(res) {
      this.getUrlNames();
    },
    UploadImage: function UploadImage(param) {// 上传文件
      var self = this;
      var formData = new FormData();
      formData.append('file', param.file);
      if (self.addData.path === '') {
        self.postFormData('/api/faOtaVersion/upload', formData, function (res) {
          console.log('res111', res);
          var url = res.url;
          self.addData.path = res.dir;
          self.addData.urlList.push(url);
          self.$message({
            message: '添加成功!',
            type: 'success' });

          param.onSuccess();
        });
      } else {
        formData.append('path', self.addData.path);
        self.postFormData('/api/faOtaVersion/upload', formData, function (res) {
          var url = res.url;
          self.addData.md5 = res.md5;
          self.addData.path = res.dir;
          self.addData.urlList.push(url);
          self.$message({
            message: '添加成功!',
            type: 'success' });

          param.onSuccess();
        });
      }
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        enabled: item.enabled + '',
        isForce: item.isForce + '',
        firmwareDownloadType: item.firmwareDownloadType + '',
        otaVersion: item.otaVersion,
        remark: item.remark,
        firmwareType: '3',
        md5: item.md5,
        url2: item.url,
        path: item.url };

      if (item.url) {
        self.addData.urlList = self.addData.url2.split(',');
      }
      self.getUrlNames();
      self.newadd = true;
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faOtaVersion', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faOtaVersion/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        enabled: '',
        isForce: '',
        firmwareDownloadType: '',
        otaVersion: '',
        remark: '',
        firmwareType: '3',
        md5: '',
        url2: '',
        path: '' };

      this.urlNames = [];
    },
    openCopy: function openCopy(item) {
      var self = this;
      self.addData.url = item.url;
      self.newadd2 = true;
    },
    copyFun: function copyFun() {
      var url = document.querySelector('#copyObj');
      url.select(); // 选择对象
      document.execCommand('Copy');
      this.closeDiglog();
    },
    getUrlNames: function getUrlNames() {
      if (this.addData.urlList) {
        this.urlNames = [];
        for (var urlIndex in this.addData.urlList) {
          var myUrl = this.addData.urlList[urlIndex];
          var lastIndex = myUrl.lastIndexOf('/');
          this.urlNames.push(myUrl.substring(lastIndex + 1));
        }
      }
    } } };exports.default = _default;